import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { CreateManualCashSalesForm } from "./CreateManualCashSalesForm";
import { RiskCashSale } from "@/lib/api/risk/cashSales/general";

interface CreateManualCashSalesFormDialogProps {
    isOpen: boolean;
    onClose: () => void;
    onSuccess: () => void;
    initialData?: RiskCashSale | null;
}

export function CreateManualCashSalesFormDialog({ isOpen, onClose, onSuccess, initialData }: CreateManualCashSalesFormDialogProps) {
    const handleSuccess = () => {
        onSuccess();
        onClose();
    };

    return (
        <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
            <DialogContent className="sm:max-w-[90vw] md:max-w-[80vw] lg:max-w-[80vw] max-h-[90vh] overflow-y-auto">
                <DialogHeader>
                    <DialogTitle>{initialData ? 'Create Manual Cash Sale (Pre-populated)' : 'Create Manual Cash Sale'}</DialogTitle>
                    <DialogDescription>
                        {initialData ? 'Review and modify the pre-populated details before creating the manual cash sale entry' : 'Enter the details for the new manual cash sale entry'}
                    </DialogDescription>
                </DialogHeader>

                <CreateManualCashSalesForm
                    onSuccess={handleSuccess}
                    onCancel={onClose}
                    showCancelButton={true}
                    initialData={initialData}
                />
            </DialogContent>
        </Dialog>
    );
}
